<template>
  <div
    class="catalog-tree-box"
    :class="expandedArrow ? '' : 'openTree'">
    <div
      class="resource-catalog-box-tree"
      :style="{ width: width + 'px' }"
      v-show="expandedArrow">
      <div class="header">
        <span class="title">资源目录</span>
        <div
          class="operate-area"
          v-show="expandedArrow">
          <div class="icon-btn-box">
            <i
              v-show="openSilderMenu"
              class="el-icon-arrow-up icon"
              @click="setAllExpand(true)"
              title="展开全部"></i>
            <i
              v-show="!openSilderMenu"
              class="el-icon-arrow-down icon"
              @click="setAllExpand(false)"
              title="折叠全部"></i>
          </div>
          <!-- <div class="icon-btn-box">
            <icon-svg
              icon-class="ic-a-ico_Packup"
              class="icon"
              title="收起目录树"
              @click.native="hideCatalogTree" />
          </div> -->
        </div>
      </div>

      <div class="common-tree-box">
        <el-tree
          class="tree-primary"
          ref="tree"
          :data="data"
          :props="defaultProps"
          node-key="nodeId"
          highlight-current
          :default-expanded-keys="['00000000-0000-0000-0000-000000000000']"
          :expand-on-click-node="false"
          @node-click="handleNodeClick">
          <div
            slot-scope="{ node, data }"
            class="custom-node-box">
            <div
              class="rename-box"
              v-if="data.editFlag && isSelected(data)">
              <div class="common-input-box">
                <el-input
                  class="input-primary"
                  size="small"
                  :maxlength="20"
                  :value="data.nodeName"
                  @click.stop.native="e => e.stopPropagation()"
                  @input="value => editNodeName(data, value)"
                  autocomplete="off"
                  placeholder="请输入名称" />
              </div>
              <div class="action-button-box">
                <i
                  class="el-icon-check submit-btn"
                  @click="e => saveNodeName(data, e)" />
                <i
                  class="el-icon-close cancel-btn"
                  @click="e => cancelEditNodeName(data, e)" />
              </div>
            </div>
            <div
              v-else
              class="node-content-box">
              <div class="node-label-box">
                <div
                  class="text-overflow"
                  :title="data.nodeName">
                  <span class="node-label">{{ data.nodeName }}</span>
                  <span class="node-label">{{
                    data.count ? `(${data.count})` : ''
                  }}</span>
                </div>
              </div>
              <div class="custom-button-box">
                <el-button
                  class="cus-icon-btn"
                  type="text"
                  size="small"
                  title="新建分组"
                  v-if="isButtonVisible('NewGroup') && node.level < 4"
                  @click="e => addNode(data, e)">
                  <icon-svg
                    size="14"
                    icon-class="ic-tianjiawenjianjia"
                    class="icon" />
                </el-button>
                <el-button
                  class="cus-icon-btn"
                  v-if="
                    isButtonVisible('EditGroupName') &&
                    data.nodeType &&
                    data.nodeType.value !== 0
                  "
                  type="text"
                  size="small"
                  title="重命名"
                  @click="e => reNameNode(data, e)">
                  <icon-svg
                    size="14"
                    icon-class="ic-bianjimingcheng1"
                    class="icon" />
                </el-button>
                <el-button
                  class="cus-icon-btn"
                  v-if="
                    isButtonVisible('DeleteGroup') &&
                    data.nodeType &&
                    data.nodeType.value !== 0
                  "
                  type="text"
                  size="small"
                  title="删除"
                  @click="e => deleteNode(data, e)">
                  <i
                    size="14"
                    class="el-icon-delete icon"></i>
                </el-button>
              </div>
            </div>
          </div>
        </el-tree>
      </div>
    </div>
    <div
      class="expaned"
      @click="() => (expandedArrow = !expandedArrow)">
      <i
        v-if="!expandedArrow"
        size="14"
        class="el-icon-arrow-right el-icon"></i>
      <i
        v-else
        size="14"
        class="el-icon-arrow-left el-icon"></i>
    </div>
  </div>
</template>

<script>
import { Store } from '@/utils/store'
import { getParentNode, guid } from '@/utils/generalMethods'

import {
  publicElemCatalogService,
  publicElemAddLevelNodeService,
  publicElemDeleteLevelNodeService,
  publicElemUpdateNodeNameService,
  privateElemCatalogService,
  privateElemAddLevelNodeService,
  privateElemDeleteLevelNodeService,
  privateElemUpdateNodeNameService
} from '@/service/interface'
export default {
  data() {
    return {
      defaultProps: {
        children: 'nodes',
        label: 'nodeName'
      },
      selectedNode: {},
      openSilderMenu: true,
      expandedArrow: true
    }
  },
  props: {
    type: String,
    userId: String,
    data: Array,
    updateData: Function,
    nodeClick: Function,
    hideCatalogTree: Function,
    width: Number
  },
  methods: {
    handleNodeClick(nodeData, node) {
      this.nodeClick(nodeData, node)
    },
    getNode(nodeId) {
      let node = this.$refs.tree.getNode(nodeId)
      return node
    },
    setCurrentKey(nodeId) {
      if (!nodeId) {
        this.$refs.tree.setCurrentKey(null)
        return
      }
      let node = this.getNode(nodeId)
      if (node) {
        let parentNodes = []
        this.getParentNode(node, parentNodes)
        for (let i in parentNodes) {
          parentNodes[i].expanded = true
        }
        this.$refs.tree.setCurrentKey(nodeId)
      }
    },
    setAllExpand(state) {
      let nodes = this.$refs.tree.store._getAllNodes()
      setTimeout(() => {
        nodes.forEach(element => {
          element.expanded = state
        })
      }, 0)
      this.openSilderMenu = !this.openSilderMenu
    },
    addNode(nodeData, e) {
      e && e.stopPropagation()
      if (this.selectedNode.editFlag) {
        let message = '存在正在编辑的节点，请编辑完成后再添加节点。'
        this.$message.warning(message)
        return
      }

      let node = this.$refs.tree.getNode(nodeData.nodeId)
      node.expanded = true

      let newNodeData = {
        nodeId: guid(),
        parentId: nodeData.nodeId,
        nodeName: '',
        newNodeFlag: true,
        editFlag: true
      }

      let isTrueNode = this.isTrueNode(nodeData)
      if (isTrueNode) {
        nodeData.nodes.push(newNodeData)
      } else {
        nodeData.nodes = [newNodeData]
      }
      this.selectedNode = newNodeData
    },
    reNameNode(nodeData, e) {
      e && e.stopPropagation()
      if (this.selectedNode.editFlag) {
        let message = '存在正在编辑的节点，请编辑完成后再选择其它节点。'
        this.$message.warning(message)
        return
      }
      this.$set(nodeData, 'editFlag', true)
      this.selectedNode = nodeData
    },
    editNodeName(nodeData, value) {
      this.$set(nodeData, 'nodeName', value)
    },
    saveNodeName(nodeData, e) {
      e && e.stopPropagation()
      let value = nodeData.nodeName
      if (value.length !== value.trim().length) {
        this.$message.warning('开头和结尾不允许有空格')
        return
      }
      if (nodeData.newNodeFlag) {
        this.createLevelNode(nodeData)
      } else {
        this.updateNodeName(nodeData)
      }
    },
    createLevelNode(nodeData) {
      let params = {
        parentId: nodeData.parentId,
        nodeName: nodeData.nodeName
      }
      if (this.type === 'PublicElem') {
        publicElemAddLevelNodeService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let nodeId = data.nodeId
            this.updateData(nodeId).then(() => {
              this.$message.success('新建分组成功')

              let node = this.$refs.tree.getNode(nodeId)
              node.expanded = false

              nodeData.editFlag = false
              nodeData.newNodeFlag = false
              this.selectedNode = {}
            })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      } else {
        privateElemAddLevelNodeService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let nodeId = data.nodeId
            this.updateData(nodeId).then(() => {
              this.$message.success('新建分组成功')

              let node = this.$refs.tree.getNode(nodeId)
              node.expanded = false

              nodeData.editFlag = false
              nodeData.newNodeFlag = false
              this.selectedNode = {}
            })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      }
    },
    updateNodeName(nodeData) {
      let params = {
        nodeId: nodeData.nodeId,
        nodeName: nodeData.nodeName
      }
      if (this.type === 'PublicElem') {
        publicElemUpdateNodeNameService(params).then(response => {
          if (response.isSuccess) {
            nodeData.editFlag = false
            this.selectedNode = {}

            this.$message.success('修改分组成功')
          } else {
            this.$message.error(response.errMsg)
          }
        })
      } else {
        privateElemUpdateNodeNameService(params).then(response => {
          if (response.isSuccess) {
            nodeData.editFlag = false
            this.selectedNode = {}

            this.$message.success('修改分组成功')
          } else {
            this.$message.error(response.errMsg)
          }
        })
      }
    },
    cancelEditNodeName(nodeData, e) {
      e && e.stopPropagation()
      if (nodeData.newNodeFlag) {
        this.cancelCreateNode(nodeData)
      } else {
        this.cancelUpdateNodeName(nodeData)
      }
    },
    cancelCreateNode(nodeData) {
      let findNode = this.findNodeById(this.data, nodeData.parentId)
      let nodes = findNode.nodes
      let findIndex = nodes.findIndex(el => el.nodeId === nodeData.nodeId)
      if (findIndex !== -1) {
        nodes.splice(findIndex, 1)
      }
      this.selectedNode = {}

      // this.$message.info('取消新增')
    },
    cancelUpdateNodeName(nodeData) {
      const rootId = '00000000-0000-0000-0000-000000000000'
      if (this.type === 'PublicElem') {
        let params = {
          parentId: rootId,
          returnCount: true,
          lazyLoading: true
        }
        publicElemCatalogService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let nodes = data.nodes
            let originNodeData = this.findNodeById(nodes, nodeData.nodeId)
            this.$set(nodeData, 'nodeName', originNodeData.nodeName)
            this.$set(nodeData, 'editFlag', false)
            this.selectedNode = {}

            this.$message.info('取消修改')
          } else {
            this.$message.error(response.errMsg)
          }
        })
      } else {
        let userInfo = Store.userInfo
        let userId = this.userId ? this.userId : userInfo.userId
        let params = {
          parentId: rootId,
          userId: userId,
          returnCount: true,
          lazyLoading: false
        }
        privateElemCatalogService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let nodes = data.nodes
            let originNodeData = this.findNodeById(nodes, nodeData.nodeId)
            this.$set(nodeData, 'nodeName', originNodeData.nodeName)
            this.$set(nodeData, 'editFlag', false)
            this.selectedNode = {}

            this.$message.info('取消修改')
          } else {
            this.$message.error(response.errMsg)
          }
        })
      }
    },
    deleteNode(nodeData, e) {
      e && e.stopPropagation()
      let message = '该操作将删除分组以及分组下的所有模型，是否继续?'
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          if (this.type === 'PublicElem') {
            let nodeId = nodeData.nodeId
            let node = this.$refs.tree.getNode(nodeId)
            let parentNode = node.parent
            publicElemDeleteLevelNodeService({ nodeId }).then(response => {
              if (response.isSuccess) {
                let parentNodeData = parentNode.data
                this.updateData(parentNodeData, nodeId).then(() => {
                  this.$message.success('删除分组成功')
                })
              }
            })
          } else {
            let nodeId = nodeData.nodeId
            privateElemDeleteLevelNodeService({ nodeId }).then(response => {
              if (response.isSuccess) {
                this.updateData(nodeId).then(() => {
                  this.$message.success('删除分组成功')
                })
              }
            })
          }
        })
        .catch(() => {
          // this.$message.info('取消删除')
        })
    },
    isSelected(nodeData) {
      return this.selectedNode.nodeId === nodeData.nodeId
    },
    isTrueNode(nodeData) {
      let isTrueNodeFlag = false
      if (!nodeData.nodes) return isTrueNodeFlag

      let nodes = nodeData.nodes
      isTrueNodeFlag = nodes.every(el => el.nodeId)
      return isTrueNodeFlag
    },
    findNodeById(data, id) {
      for (const node of data) {
        if (node.nodeId === id) return node
        if (node.nodes && node.nodes.length) {
          const res = this.findNodeById(node.nodes, id)
          if (res) return res
        }
      }
      return null
    },
    isButtonVisible(btnName) {
      if (this.type === 'PublicElem') {
        return this.isChecked(`Project.ComponentLibrary.Public.${btnName}`)
      } else {
        // 对于超级管理员，如果是超管自己登录且用户筛选选择本身可以正常操作
        if (this.isSuperAdmin()) {
          let userInfo = Store.userInfo
          if (userInfo.userId === this.userId) {
            return true
          } else {
            return false
          }
        } else {
          return this.isChecked(`Project.ComponentLibrary.Private.${btnName}`)
        }
      }
    },
    isSuperAdmin() {
      return this.isChecked('Project.ComponentLibrary.Private.UserFilter')
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    getParentNode
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';

.openTree {
  .expaned {
    right: -12px !important;
    z-index: 9;
    display: block !important;
  }
}

.resource-catalog-box-tree {
  padding: 16px;
  transition: all 0.3s;
  height: 100%;
}

.catalog-tree-box {
  height: 100%;
  border-radius: 16px;
  background: var(--element-page-tree-bgColor);
  position: relative;
  margin-right: 16px;
  transition: all 0.3s;
  &:hover {
    .expaned {
      display: block;
    }
  }

  .expaned {
    width: 24px;
    height: 40px;
    border-radius: 16px;
    background-color: var(--scene-edit-left-expand-bgColor);
    box-shadow: var(--base-bg-dark-color30);
    border: 1px solid var(--scene-edit-left-expand-bgColor);
    position: absolute;
    top: 50%;
    right: -12px;
    transform: translateY(-50%);
    display: none;
    line-height: 40px;
    cursor: pointer;
    &:hover {
      background-color: var(--scene-edit-left-expand-hover-bgColor);
      box-shadow: var(--base-bg-dark-color30);
      border-color: transparent;
      border-radius: 16px;
    }

    .el-icon {
      font-weight: 600;
      color: var(--scene-edit-left-expand-icon-color);
    }
  }

  .header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;

    .title {
      font-size: 16px;
      color: var(--element-page-tree-title);
    }

    .operate-area {
      display: flex;
      height: 26px;
      .icon-btn-box {
        // margin-left: 5px;
        // padding: 0px 5px;
        // line-height: 26px;
        // border-radius: 2px;
        // background: var(--icon-bg-color);
        .icon {
          color: var(--element-page-tree-icon-color);
          font-size: 14px;
          cursor: pointer;

          &:hover {
            color: var(--base-primary-bgColor);
          }
        }
      }
    }
  }

  .common-tree-box {
    height: calc(100% - 30px);
    overflow-y: auto;

    .rename-box {
      display: flex;
      width: 100%;

      .common-input-box {
        flex-grow: 1;
        margin-bottom: 1px;
        :deep(.el-input__inner) {
          height: 26px;
        }
      }

      .action-button-box {
        margin: 0px 10px;
        line-height: 26px;

        .submit-btn {
          color: var(--base-light-color3);
        }

        .cancel-btn {
          margin-left: 10px;
          color: var(--base-light-color4);
        }
      }
    }

    .custom-node-box {
      width: calc(100% - 20px);

      .node-content-box {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .node-label-box {
          display: flex;
          align-items: center;
          flex-grow: 1;
          overflow: hidden;

          .text-overflow {
            display: flex;
            align-items: center;
            flex: 1;
            color: var(--tree-node-text-color);
          }

          .node-label {
            font-size: 14px;

            &:first-child {
              width: auto;
              max-width: calc(100% - 30px);
              // max-width: calc(100% - 30px);
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          .icon-box {
            display: none;
            margin-left: 5px;

            .icon {
              color: var(--default-color);
            }
          }

          &:hover {
            .icon-box {
              display: block;
            }
          }
        }

        .custom-button-box {
          margin: 0px 5px;
          display: flex;
          align-items: center;
          .el-button {
            margin-right: 0px;
            padding: 0;

            :deep(.svg-icon) {
              &:hover {
                use {
                  color: var(--base-primary-bgColor);
                }
              }
            }

            .icon {
              &:hover {
                color: var(--base-primary-bgColor);
              }
            }
          }

          .cus-icon-btn {
            font-size: 16px;
            color: var(--tree-node-text-color);
          }
        }
      }
    }
  }
}

.openTree {
  margin-right: 0px;
  border: none;
}
</style>
